import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

const PDF_PAGE_MARGIN = 5;

function getPageBreakCandidates(content, canvas) {
  const contentRect = content.getBoundingClientRect();
  const canvasHeightRatio = canvas.height / content.scrollHeight;
  const positions = [];

  Array.prototype.forEach.call(content.children, element => {
    if (!element.classList.contains('MuiGrid-container')) {
      return;
    }

    const position = Math.round(
      (element.getBoundingClientRect().bottom - contentRect.top)
      * canvasHeightRatio
    );

    if (position > 0 && position < canvas.height) {
      positions.push(position);
    }
  });

  positions.push(canvas.height);
  positions.sort((first, second) => first - second);

  return positions.filter((position, index) => (
    index === 0 || position !== positions[index - 1]
  ));
}

function getSectionEnd(candidates, sectionStart, maximumSectionEnd, canvasHeight) {
  let sectionEnd = 0;

  for (let index = 0; index < candidates.length; index += 1) {
    const position = candidates[index];

    if (position > sectionStart && position <= maximumSectionEnd) {
      sectionEnd = position;
    }
  }

  return sectionEnd || Math.min(maximumSectionEnd, canvasHeight);
}

function createSectionCanvas(canvas, sectionStart, sectionHeight) {
  const sectionCanvas = document.createElement('canvas');

  sectionCanvas.width = canvas.width;
  sectionCanvas.height = sectionHeight;

  const context = sectionCanvas.getContext('2d');

  if (!context) {
    throw new Error('Não foi possível preparar uma página do PDF.');
  }

  context.drawImage(
    canvas,
    0,
    sectionStart,
    canvas.width,
    sectionHeight,
    0,
    0,
    canvas.width,
    sectionHeight
  );

  return sectionCanvas;
}

export async function exportOperationsDashboardPdf({ elementId, fileName }) {
  const content = document.getElementById(elementId);

  if (!content) {
    throw new Error('Conteúdo do dashboard não encontrado para exportação.');
  }

  if (document.fonts && document.fonts.ready) {
    await document.fonts.ready;
  }

  const canvas = await html2canvas(content, {
    backgroundColor: '#ffffff',
    logging: false,
    scale: 2,
    useCORS: true,
    windowHeight: content.scrollHeight,
    windowWidth: content.scrollWidth,
  });
  const pdf = new jsPDF('landscape', 'mm', 'a4');
  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();
  const availableWidth = pageWidth - PDF_PAGE_MARGIN * 2;
  const availableHeight = pageHeight - PDF_PAGE_MARGIN * 2;
  const maxCanvasHeightPerPage = Math.floor(
    canvas.width * availableHeight / availableWidth
  );
  const pageBreakCandidates = getPageBreakCandidates(content, canvas);

  let sectionStart = 0;
  let pageIndex = 0;

  while (sectionStart < canvas.height) {
    const maximumSectionEnd = sectionStart + maxCanvasHeightPerPage;
    const sectionEnd = getSectionEnd(
      pageBreakCandidates,
      sectionStart,
      maximumSectionEnd,
      canvas.height
    );
    const sectionHeight = sectionEnd - sectionStart;
    const sectionCanvas = createSectionCanvas(
      canvas,
      sectionStart,
      sectionHeight
    );

    let renderedWidth = availableWidth;
    let renderedHeight = sectionHeight * renderedWidth / canvas.width;

    if (renderedHeight > availableHeight) {
      renderedHeight = availableHeight;
      renderedWidth = canvas.width * renderedHeight / sectionHeight;
    }

    if (pageIndex > 0) {
      pdf.addPage();
    }

    pdf.addImage(
      sectionCanvas.toDataURL('image/png'),
      'PNG',
      (pageWidth - renderedWidth) / 2,
      PDF_PAGE_MARGIN,
      renderedWidth,
      renderedHeight
    );

    sectionStart = sectionEnd;
    pageIndex += 1;
  }

  pdf.save(fileName);
}
